import { TFunction } from "i18next";
import i18n from "../i18n";
import toast from "ui/Toast";
import { setUserNotHavePermission } from "services/LocalStorage.service";
import moment from "moment-timezone";

export function getOrgCode(host: string) {
  // we use localhost domain is for Cypress testing
  // as at the moment still not find out the way to run custom QSHIP domain for bitbucket pipeline
  // when the domain is localhost, the org code is always QUINCUS
  if (host === "localhost") return process.env.REACT_APP_ORGANISATION_CODE;

  let parts = host.split(".");
  if (parts.length === 2) return "www";
  return parts[0];
}

export function getSubdomain(host) {
  // we use localhost domain is for Cypress testing
  // as at the moment still not find out the way to run custom QSHIP domain for bitbucket pipeline
  // when the domain is localhost, the org code is always QUINCUS
  const url = window.location.hostname;
  if (url === "localhost") return process.env.REACT_APP_ORGANISATION_CODE;

  return localStorage.getItem("orgCode");
}

export function comodityFun(val: any) {
  const array = val.map(function (iter: any, index: number) {
    return index > 0 ? " " + iter.name : iter.name;
  });
  return array.toString();
}

export function totalComodityFun(val: any) {
  if (!val || !val.length) return;
  let array = [];
  let comodityShow = [];
  let total = 0;

  val.forEach((item) => {
    if (
      item.commodities &&
      item.commodities.length > 0 &&
      item.commodities_packages &&
      item.commodities_packages.length > 0
    )
      item.commodities.forEach((item_arr, index) => {
        if (item_arr.id && item_arr.name && item.commodities_packages[index].items_count) {
          let obj = {
            id: null,
            name: null,
            amount: 0,
          };
          let indexArray = array.findIndex((item) => item.id === item_arr.id);
          if (indexArray >= 0) {
            array[indexArray].amount += parseInt(item.commodities_packages[index].items_count);
          } else {
            obj = {
              id: item_arr.id,
              name: item_arr.name,
              amount: parseInt(item.commodities_packages[index].items_count),
            };
            array.push(obj);
          }
        }
      });
  });
  if (array.length > 0) {
    array.forEach((item) => {
      total += item.amount;
      comodityShow.push(`${item.name} (${item.amount})`);
    });
  }
  return `${total} ${
    total > 0
      ? total > 1
        ? i18n.t("qchoice:detail.detail.str_items") + ":"
        : i18n.t("qchoice:detail.detail.str_item") + ":"
      : i18n.t("qchoice:detail.detail.str_item")
  } ${comodityShow.join(", ")}`;
}

export function totalWeightFun(val: any) {
  if (!val || !val.length) return 0;

  let total = 0;
  val.forEach(function (iter: any) {
    total = total + iter.chargeable_weight;
  });
  return total;
}

export const getDistinctPackaging = (packages: any[]) => {
  const packaging: any = {};
  let packageId: string = "";

  packages.forEach(item => {
    packageId = item.packaging?.id;
    if (!packaging.hasOwnProperty(packageId)) {
      packaging[packageId] = {
        id: packageId,
        name: item.package_type,
      }
    }
  });

  return packaging;
}

export const getDistinctCommodities = (packages: any[]) => {
  let packageCommodities: any = {};
  let commoditiesCount = 0;

  packages.forEach((item: any) => {
    item.commodities_packages.forEach((i: any) => {
      if (!packageCommodities.hasOwnProperty(i.commodity_id)) {
        packageCommodities[i.commodity_id] = {
          name: i.commodity_name,
          quantity: i.items_count,
          commodityCode: i.code,
          HSCode: i.hs_code,
          commodityPackagingType: i.packaging_type,
          description: i.description,
          notes: i.note,
          id: i.commodity_id,
        };
      } else {
        packageCommodities[i.commodity_id].quantity = packageCommodities[i.commodity_id].quantity + i.items_count;
      }

      commoditiesCount += i.items_count ? i.items_count : 0;
    });
  });

  return {
    packageCommodities,
    commoditiesCount,
  };
};

export function totalPackageType(val: any) {
  if (!val) return;
  let array = [];
  let indexCount = [];
  val.forEach(function (iter: any) {
    if (!array.includes(iter.package_type)) {
      array.push(iter.package_type);
      indexCount.push(1);
    } else {
      let index = array.indexOf(iter.package_type);
      indexCount[index] = indexCount[index] + 1;
    }
  });

  let finalArray = [];
  array.forEach(function (itr: any, pos: number) {
    let final = `${itr} (${indexCount[pos]})${pos !== array.length - 1 ? ", " : ""}`;
    finalArray.push(final);
  });

  return finalArray;
}

export function totalValueOfGoods(val: any) {
  if (!val || !val.length) return 0;

  let total = 0;
  val.forEach(function (iter: any) {
    total = total + iter.value_of_goods;
  });
  return total;
}

export function copyTrackingUrl(url: string) {
  try {
    navigator.clipboard.writeText(url);
    /* const el = document.createElement('textarea');
    el.value = url;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el); */
    toast.success(i18n.t("qchoice:popup.toast.copy_success_message"));
  } catch (e) {
    toast.error(i18n.t("qchoice:popup.toast.something_error_message"));
  }
}

export const renderPlural = (val: number, singularText?: string, pluralText?: string) => {
  const plural =
    val > 1
      ? pluralText || i18n.t("qchoice:create_single_order.str_items")
      : singularText || i18n.t("qchoice:create_single_order.str_item");
  return `${val} ${plural}`;
};

// This method is for get exactly length of string
export const getLength = (val: string) => {
  return val.replace(/(\r\n|\n|\r)/gm, " ").length;
};

export const logOutSteps = (history?: any, userNotHavePermission?: boolean) => {
  const logoutUrl = localStorage.getItem("logout_url");
  const orgCode = localStorage.getItem("orgCode");
  localStorage.clear();
  localStorage.setItem("orgCode", orgCode);
  if (userNotHavePermission) setUserNotHavePermission("The account does not have permission to access this portal, please contact System Admin for more details.");
  if (logoutUrl) {
    window.location.href = `${logoutUrl}?qship_url=${window.location.origin}`;
  } else if (history) history.push("/");
};

// get timezone offset
export const getTimezoneOffset = (date: any = new Date(), timeZone: string = "UTC") => {
  const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
  const tzDate = new Date(date.toLocaleString("en-US", { timeZone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4;
};

// get UTC based on country timezone
export const getUTCTimezone = (timezone: string, isFullStringFormat?: boolean) => {
  if (!timezone) return "";
  const offset = getTimezoneOffset(new Date(), timezone);
  let utc = numberToTime(offset);
  return isFullStringFormat ? `UTC${utc}` : utc;
};

export const getUTC = (timezone: string, isFullStringFormat?: boolean) => {
  if (!timezone) return "";
  const utc = timezone.slice(3);
  if (isFullStringFormat) return `UTC${utc}`;
  return utc;
};

export const numberToTime = (number: number) => {
  let isNegative = false;
  if (number < 0) {
    isNegative = true;
    number = Math.abs(number);
  }
  let hours = Math.floor(number / 60).toString();
  let minutes = (number % 60).toString();

  if (hours.length < 2) {
    hours = "0" + hours;
  }
  if (minutes.length < 2) {
    minutes = "0" + minutes;
  }
  return (isNegative ? "-" : "+") + hours + ":" + minutes;
};

export const formatBytes = (bytesParam: number | string, decimals: number = 1) => {
  const bytes = +bytesParam;
  if (!bytes) return "0 B";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const handleDownloadFile = async (fileUrl: string, fileName: string) => {
  const file = await (await fetch(fileUrl)).blob();
  const fileURL = URL.createObjectURL(file);

  const link = document.createElement("a");
  link.href = fileURL;
  link.target = "_blank";
  link.download = fileName;
  link.click();
};

export const titleCase = (str: any) => {
  if (str) {
    let splitStr = str.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  } else {
    return "";
  }
};

export const getPackageName = (translator: TFunction, packageInfo: any, packageTypes: any[]) => {
  // Check if its custom type or not
  const selectedPackage = packageTypes.find((packageType) => packageType.value === packageInfo.packageType);
  // Check if custom type is selected
  if (selectedPackage?.custom) {
    // Check if custom type name is entered
    if (packageInfo.custom_package_type) {
      return `${translator("create_single_order.str_custom_type")} - ${packageInfo.custom_package_type}`;
    }
    return `${translator("create_single_order.str_custom_type")}`;
  }
  return null;
};

// This will take object company name and department name this will return concatinated string according to the condition
export const companyAndDepartmentFormatter = (company: string, department: string) => {
  if (company || department) {
    if (company && department) {
      return `${company}, ${department}`;
    }
    return company || department;
  }

  return "";
};

// Handle Image Download
export const toDataURL = (url: string) => {
  return fetch(url, { cache: "no-cache" })
    .then((response) => response.status === 200 && response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          if (blob) {
            reader.readAsDataURL(blob);
          }
        })
    )
    .catch((error) => {
      console.error("error download image", error);
    });
};

export const handleDownloadImage = (url: string, fileName: string) => {
  if (!url) return;
  toDataURL(url)
    .then((dataUrl) => {
      const a: any = document.createElement("a");
      a.href = dataUrl;
      a.download = fileName;
      a.click();
    })
    .catch(() => {
      toast.error("Error downloading image");
    });
};

export const generateTimeLabel = (time: string, format?: string) => {
  if (moment(time).isValid()) {
    if (format) return moment(time).format(format);
    return moment.parseZone(time).format("DD MMM HH:mm");
  }

  return "";
}

export const generateTimeByTimezone = (time: string, timezone: string, format?: string) => {
  if (!time || !moment(time).isValid()) return "";

  let dateTime;
  if (!timezone) dateTime = moment.parseZone(time);
  else dateTime = moment(time).tz(timezone);

  return format ? dateTime.format(format) : dateTime.format("DD MMM HH:mm");
}

export const getZoneByTimezone = (timezone: string, isFullStringFormat?: boolean) => {
  if (!timezone) return "";
  let zone = moment.tz(timezone).format("Z");
  return isFullStringFormat ? `UTC${zone}` : zone;
}

export const utc0Timezone = (isFullStringFormat?: boolean) => {
  return isFullStringFormat ? `UTC+00:00` : "+00:00";
}

export const generateTimeWithTimezoneOffset = (time: string, format?: string) => {
  if (!time || !moment(time).isValid()) return "";

  const dateTime = moment(time);

  return format ? dateTime.format(format) : dateTime.format("DD MMM HH:mm");
}

export const getOrderReferenceLabel = (reference , t)=>{
   return reference?.external_id === "customer_order_id" ? t("detail.navigator.str_customer_order_id")  :  reference.label || reference.external_id;
}

export const getTimezoneFromTime = (time: string, isFullStringFormat?: boolean) => {
  if (!time) return "";
  const timezone = time.slice(-6);
  return isFullStringFormat ? `UTC${timezone}` : timezone;
};

export const encodeParams = (arr: string[]) => {
  return arr.map((item: any) => encodeURIComponent(item));
};

export const removeDuplicateValue = (val: string[]) => {
  return [...new Set(val)];
};

export const convertFirstLetterToUpper = (str: string) => {
  if (!str) return "";

  const firstLetter = str.charAt(0).toUpperCase();
  const restOfString = str.slice(1).toLowerCase();

  return firstLetter + restOfString;
}

export const isValidUuid = (id: string) => {
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return regex.test(id);
}

export const decimalRound = (value: number, precision: number) => {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export const isValidCoordinates = (coordinates = []) => {
  if (coordinates && coordinates.length === 2 && coordinates[0] && coordinates[1])
    if (coordinates[0] > -180 && coordinates[0] < 180 && coordinates[1] > -90 && coordinates[1] < 90) return true;
  return false;
};

export const toDegreesMinutesAndSeconds = (coordinate: number) => {
  const absolute = Math.abs(coordinate);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = decimalRound((minutesNotTruncated - minutes) * 60, 1);

  return `${degrees}°${minutes}'${seconds}"`;
}

// Convert lat long from decimal degrees to DMS format (41°24'12.2"N, 2°10'26.5"E)
export const convertDMS = (coordinates = []) => {
  if (!isValidCoordinates(coordinates)) return "";

  const lat = coordinates[1];
  const lng = coordinates[0];

  const latitude = toDegreesMinutesAndSeconds(lat);
  const latitudeCardinal = lat >= 0 ? "N" : "S";

  const longitude = toDegreesMinutesAndSeconds(lng);
  const longitudeCardinal = lng >= 0 ? "E" : "W";

  return `${latitude}${latitudeCardinal}, ${longitude}${longitudeCardinal}`;
}

export const fileNameWithoutExtension = (fileName: string) => {
  if (!fileName) return "";
  return fileName.substring(0, fileName.lastIndexOf("."));
}